import React from 'react';
import api from 'api';
import jwtDecode from 'jwt-decode';
import { Tabs, Tab } from 'react-bootstrap';
import { Spinner, AlertMessage, Modal } from 'hyperdb-utils';
import MessagesHistory from './MessagesHistory';
import DisplayMessage from '../components/DisplayMessage';
import ItemActions from '../components/ItemActions';
import ModalForward from '../components/ModalForward';
import ModalAttachBooking from '../components/ModalAttachBooking';
import {
  CustomerDetails, ReservationInfo,
  ReservationRemarksContainer, ReservationGuestsDetails, ReservationPricesDetails
} from '../../../daily-rental/common';
import { Form as InquiryForm } from '../../../daily-rental/inquiry/components';
import { Calendar } from '../../../daily-rental/availabilities/containers';
import { FILESTORE_URL } from '../../../../../config';
import { parseMail } from '../../../../../backend/email/api/parsing';

class Show extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.handleCustomerUpdated = this.handleCustomerUpdated.bind(this);
    this.handleCreateInquiry = this.handleCreateInquiry.bind(this);
    this.handleChangeMessageToForward = this.handleChangeMessageToForward.bind(this);
    this.handleConfirmForward = this.handleConfirmForward.bind(this);
    this.handleChangeAttachParams = this.handleChangeAttachParams.bind(this);
    this.handleSearchBookings = this.handleSearchBookings.bind(this);
    this.handleConfirmAttach = this.handleConfirmAttach.bind(this);
    this.handleReservationOnActionSuccessful = this.handleReservationOnActionSuccessful.bind(this);
    this.handleChangeSearchParams = this.handleChangeSearchParams.bind(this);
    this.handleActionSuccessful = this.handleActionSuccessful.bind(this);
  }
  componentDidMount() {
    this.props.api.message.getObject(this.props.params.id);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.props.api.message.setData({ messageInit: false });
      this.props.api.message.getObject(nextProps.params.id);
    }
    if (!nextProps.messageInit && nextProps.objectFecthed && nextProps.objectData) {
      let message = nextProps.objectData;
      this.props.api.message.setData({ messageInit: true, message, objectData: null });
      this.props.api.message.getData({ url: `/${nextProps.params.id}/content` })
        .then(content => {
          const { body, text, attachments } = content;
          message = { ...message, body, text, attachments };
          if (this.canCreateInquiry(message)) {
            const { inquiry, client } = parseMail(message);
            this.props.api.inquiry.setData({ objectData: inquiry });
          }
          this.props.api.message.setData({ message });
        });
      if (message.related_object_reference) {
        this.getRelatedObject(message);
      }
    }
    const inquirySaved = this.props.api.getState('inquiry').savedObject;
    const reservationSaved = this.props.api.getState('reservation').savedObject;
    if (inquirySaved || reservationSaved) {
      const reference = inquirySaved ? inquirySaved.reference : reservationSaved.reference;
      const message = { ...this.props.message, related_object_type: inquirySaved ? 'inquiry' : 'reservation', related_object_reference: reference };
      this.props.api.message.setData({ message });
      this.getRelatedObject(message);
      this.props.api[message.related_object_type].setData({ savedObject: null, submitSuccessful: false });
      this.props.api.message.setData({ successMessage: `${message.related_object_type} saved` });
    }
  }
  componentWillUnmount() {
    this.props.api.message.setData({ message: null, objectFecthed: false, messageInit: false, searchParams: {}, showModalCalendar: false });
    this.props.api.inquiry.setData({ objectData: null });
    this.toggleModalAttachBooking(false);
  }
  render() {
    if (!this.props.objectFecthed || !this.props.message) return <div className="box"><Spinner show={ true } /></div>;
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row">
            <div className="col-md-12">
              <span className="btn btn-sm btn-primary" onClick={ this.handleClickBack }>
                <i className="fas fa-chevron-left"></i> Back
              </span>
              <h3 className="box-title">
                { this.props.message.subject }
                &nbsp;<div style={{display: 'inline-block'}}>
                  <ItemActions
                    { ...this.props }
                    forDisplay={ true }
                    mountedUrl="/email/messages"
                    message={ this.props.message }
                    folder={ this.props.message.folder }
                    onForward={ this.toggleModalForward.bind(this, true) }
                    onAttachBooking={ this.toggleModalAttachBooking.bind(this, true) }
                    onChangeSearchParams={ this.handleChangeSearchParams }
                    onActionSuccessful={ this.handleActionSuccessful }
                    label={ <i className="fas fa-cog" /> } />
                </div>
              </h3>
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          <div className="box box-primary">
            {
              this.props.successMessage
                ? <AlertMessage
                    type="success"
                    onDismiss={ this.props.api.message.dismissAlert }>
                      { this.props.successMessage }
                  </AlertMessage>
                : null
            }
            {
              this.props.errorMessage
                ? <AlertMessage
                    type="error"
                    onDismiss={ this.props.api.message.dismissAlert }>
                      { this.props.errorMessage }
                  </AlertMessage>
                : null
            }
            <Spinner show={ this.props.loading || this.props.api.getState('inquiry').loading } />
            <div className="hyperdb-form">
              <Tabs defaultActiveKey={1}>
                <Tab eventKey={1} title="Message">
                  <br/>
                  <DisplayMessage email={ this.props.message } attachmentsBaseUrl={ this.attachmentsBaseUrl() } showAttachments={ true } />
                </Tab>
                {
                  this.canCreateInquiry(this.props.message) && this.props.api.getState('inquiry').objectData
                    ? <Tab eventKey={2} title="Create inquiry">
                        <br/>
                        <div className="box-body" style={ { overflow: 'scroll', maxHeight: '450px' } }>
                          <InquiryForm />
                          <button type="button" className="btn btn-sm btn-success" onClick={ this.handleCreateInquiry } disabled={ this.props.api.getState('inquiry').loading }>
                            Create inquiry
                          </button>
                        </div>
                      </Tab>
                    : null
                }
                {
                  this.props.message.related_object_reference && this.props.relatedObject
                    ? <Tab eventKey={2} title={ this.capitalize(this.props.message.related_object_type) }>
                        <div className="box-body show-booking">
                          <ReservationInfo
                            { ...this.props }
                            reservation={ this.props.relatedObject }
                            customer={ this.props.relatedObject.customer }
                            type={ this.props.message.related_object_type }
                            withLink={ true }
                            repliedMessageId={ this.props.message.id }
                            onClickCalendar={ this.toggleModalCalendar.bind(this, true) }
                            onActionSuccessful={ this.handleReservationOnActionSuccessful } />
                          <ReservationRemarksContainer
                            { ...this.props.api.getState(this.props.message.related_object_type) }
                            reservation={ this.props.relatedObject }
                            type={ this.props.message.related_object_type }
                            api={ this.props.api }
                          />
                          <div className="row">
                            <div className="col-lg-6">
                              <ReservationGuestsDetails reservation={ this.props.relatedObject } />
                            </div>
                            <div className="col-lg-6">
                              <ReservationPricesDetails reservation={ this.props.relatedObject } />
                            </div>
                          </div>
                        </div>
                      </Tab>
                    : null
                }
                {
                  this.props.message.related_object_reference && this.props.relatedObject
                    ? <Tab eventKey={3} title="Customer">
                        <div className="box-body show-booking">
                          <CustomerDetails customer={ this.props.relatedObject.customer} onCustomerUpdated={ this.handleCustomerUpdated } />
                        </div>
                      </Tab>
                    : null
                }
                {
                  this.props.message.related_object_reference
                    ? <Tab eventKey={4} title="History">
                        <br/>
                        <div className="box-body show-booking">
                          <MessagesHistory reference={ this.props.message.related_object_reference } />
                        </div>
                      </Tab>
                    : null
                }
              </Tabs>
            </div>
          </div>
        </section>
        {
          this.props.showModalCalendar && this.props.relatedObject
            ? <Modal title="Calendar" onClose={ this.toggleModalCalendar.bind(this, false) }>
                <Calendar booking={ this.props.relatedObject } noFilters={ true } contentOnly={ true } />
              </Modal>
            : null
        }
        {
          this.props.showModalForward
            ? <ModalForward
                { ...this.props }
                onChange={ this.handleChangeMessageToForward }
                onClose={ this.toggleModalForward.bind(this, false) }
                onSubmit={ this.handleConfirmForward }
              />
            : null
        }
        {
          this.props.showModalAttachBooking
            ? <ModalAttachBooking
                { ...this.props }
                onChange={ this.handleChangeAttachParams }
                onClose={ this.toggleModalAttachBooking.bind(this, false) }
                onSearch={ this.handleSearchBookings }
                onSubmit={ this.handleConfirmAttach }
              />
            : null
        }
      </div>
    );
  }

  capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  handleClickBack() {
    if (window.previousLocation) {
      this.props.router.push(window.previousLocation);
    } else {
      this.props.api.routing.redirect(this.props.router, '/email/messages');
    }
  }
  getRelatedObject(message) {
    this.props.api.message.getData({
      url: `/get-related-object?reference=${message.related_object_reference}&type=${message.related_object_type}`
    })
    .then(relatedObject => {
      this.props.api.message.setData({ relatedObject });
    });
  }
  handleCustomerUpdated() {
    this.getRelatedObject(this.props.message);
  }
  canCreateInquiry(message) {
    if (this.props.relatedObject) return false;
    if (message.folder === 'notifications') return message.pending;
    if (message.folder === 'inbox') return message.pending && !message.related_object_reference;
    return false;
  }
  handleCreateInquiry() {
    const inquiry = this.props.api.getState('inquiry').objectData;
    if (inquiry.property.value[1] && inquiry.customer.value[1] && inquiry.arrival_date && inquiry.departure_date) {
      inquiry.original_message_id = { $type: 'reference', value: ['messages', this.props.message.id] };
      if (this.props.message.related_object_reference) inquiry.reference = this.props.message.related_object_reference;
      this.props.api.inquiry.submitCreateForm(inquiry);
    }
  }

  toggleModalCalendar(bool) {
    this.props.api.message.setData({ showModalCalendar: bool });
  }
  toggleModalForward(bool) {
    const messageToForward = bool
      ? { subject: `Fwd: ${this.props.message.subject}`, body: '', recipient: '' }
      : null;
    this.props.api.message.setData({ showModalForward: bool, messageToForward });
  }
  handleChangeMessageToForward(attributeName, field) {
    const messageToForward = { ...this.props.messageToForward, [attributeName]: field.value };
    this.props.api.message.setData({ messageToForward });
  }
  handleConfirmForward() {
    if (this.props.messageToForward.recipient) {
      this.props.api.message.postData({
        url: `/${this.props.message.id}/forward`,
        data: this.props.messageToForward
      })
      .then(() => {
        this.props.api.message.setData({ successMessage: 'Message forwarded', showModalForward: false });
        this.props.api.message.setData({ message: { ...this.props.message, forwarded: true } });
      });
    }
  }

  toggleModalAttachBooking(bool) {
    this.props.api.message.setData({ showModalAttachBooking: bool, selectedType: 'inquiry', searchReference: '', relatedObjects: null, selectedReference: null });
  }
  handleChangeAttachParams(attributeName, field) {
    let value = field.value;
    if (attributeName === 'selectedType' && !value) value = 'inquiry';
    this.props.api.message.setData({ [attributeName]: value });
  }
  handleSearchBookings() {
    this.props.api.message.setData({ relatedObjects: null, selectedReference: null });
    this.props.api.message.getData({
      url: `/find-bookings-by-reference?reference=${this.props.searchReference}&type=${this.props.selectedType}`,
      propName: 'relatedObjects',
    });
  }
  handleConfirmAttach() {
    if (this.props.selectedType && this.props.selectedReference) {
      this.props.api.message.postData({
        url: `/${this.props.message.id}/attach-to-booking`,
        data: { type: this.props.selectedType, reference: this.props.selectedReference }
      })
      .then(() => {
        const message = { ...this.props.message, related_object_type: this.props.selectedType, related_object_reference: this.props.selectedReference };
        this.props.api.message.setData({ message });
        this.getRelatedObject(message);
        this.toggleModalAttachBooking(false);
      });
    }
  }

  attachmentsBaseUrl() {
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    return `${FILESTORE_URL}/${decoded.client_id}/messages/${this.props.message.id}/attachments/`;
  }

  handleChangeSearchParams(attributeName, field) {
    const searchParams = { ...this.props.searchParams, [attributeName]: field.value };
    this.props.api.message.setData({ searchParams });
  }

  handleActionSuccessful(actionType) {
    const message = this.props.message;
    switch(actionType) {
    case 'delete':
      return this.handleClickBack();
    case 'markRead':
      message.read = true;
      break;
    case 'markUnread':
      message.read = false;
      break;
    case 'markProcessed':
      message.pending = false;
      message.read = true;
      break;
    case 'markJunk':
      message.folder = 'junk';
      message.pending = false;
      break;
    case 'markUnjunk':
      message.folder = 'inbox';
      message.pending = false;
      break;
    case 'markReplied':
      message.answered = true;
      break;
    case 'markNotReplied':
      message.answered = false;
      break;
    }
    this.props.api.message.setData({ message, successMessage: 'Action done' });
  }

  handleReservationOnActionSuccessful() {
    const message = { ...this.props.message, pending: false, read: true, answered: true };
    this.props.api.message.setData({ message });
    this.getRelatedObject(this.props.message)
      .then(() => {
        this.props.api.message.setData({ successMessage: 'Action done' });
      });
  }
}

export default api.connect(Show, 'message');



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/containers/Show.jsx